import React from 'react'
import { usePageConfigUser } from 'hooks/usePageConfig'
import { WidgetId } from 'features/types'
import { DashboardWidgetData } from 'features/widget/types'
import { SentenceRetrievalResult } from 'schemas/SentenceRetrievalResultSchema'
import { createStreamWidgetDataFromSentenceRetrieval } from './createStreamWidgetDataFromSentenceRetrieval'
import SoundbiteStream from './SoundbiteStream'

type SentenceSoundbiteStreamFactoryProps = {
  widgetId: WidgetId
  widgetData: DashboardWidgetData<SentenceRetrievalResult>
  batch: number
}

const SentenceSoundbiteStreamFactory = React.memo(
  ({ widgetId, widgetData, batch }: SentenceSoundbiteStreamFactoryProps): React.ReactElement => {
    const { timeZone } = usePageConfigUser()

    const sentenceRetrievalResult: SentenceRetrievalResult = widgetData.results![0]!.data
    const {
      soundbites,
      deletedSentenceCount,
      deletedSentenceDateRangeFrom,
      deletedSentenceDateRangeTo
    } = createStreamWidgetDataFromSentenceRetrieval(sentenceRetrievalResult, timeZone)

    const unDeletedSoundbites = soundbites.filter((soundbite) => !soundbite.deleted)

    return (
      <SoundbiteStream
        widgetId={widgetId}
        soundbites={unDeletedSoundbites}
        deletedSentenceCount={deletedSentenceCount}
        deletedSentenceDateRangeFrom={deletedSentenceDateRangeFrom!}
        deletedSentenceDateRangeTo={deletedSentenceDateRangeTo!}
        batch={batch}
      />
    )
  }
)

export default SentenceSoundbiteStreamFactory
